import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PatientCaseModel } from '../../../core/models/consultation/patient-case.model';
import { ChatService } from '../../../core/services/chat/chat.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ChatStatus } from '../../../../enums/chat-status.enum';

@Component({
  selector: 'app-case-breadcrumb',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './case-breadcrumb.component.html',
  styleUrl: './case-breadcrumb.component.scss',
})
export class CaseBreadcrumbComponent implements OnInit {
  ChatStatus = ChatStatus;
  @Input() cases: PatientCaseModel[] = [];
  @Input() activeCase: PatientCaseModel;
  @Input() loadUnreadCount = true;

  @Output() activeCaseChange = new EventEmitter<PatientCaseModel>();

  constructor(
    private chatService: ChatService,
    private translate: TranslateService
  ) {
    // const userLang = this.languageService.getLanguage() || 'en';
    // this.translate.use(userLang);
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
    // this.createPatientImageConnection();
  }

  ngOnInit(): void {
    if (this.loadUnreadCount) {
      this.unreadChatCount();
    }
  }

  async unreadChatCount() {
    const caseIds = this.cases.map((caseItem) => caseItem.patientRecordCaseId);

    const form: any = {
      patientRecordCaseIds: caseIds,
    };

    this.chatService.getUnreadChatCount(form).subscribe({
      next: async (res) => {
        this.cases = this.cases.map((caseItem) => {
          const matchedResult = res.find(
            (resultItem: any) =>
              resultItem.patientRecordCaseId === caseItem.patientRecordCaseId
          );
          return {
            ...caseItem,
            unreadCount: matchedResult ? matchedResult.unreadCount : 0,
          };
        });
      },
      error: () => {},
    });
  }

  onClickCase(item: PatientCaseModel) {
    if (this.activeCase.patientRecordCaseId === item.patientRecordCaseId)
      return;
    this.activeCase = item;
    this.activeCaseChange.emit(item);
  }

  getItemClass(item: PatientCaseModel) {
    let result = 'bcrmb-item ';
    if (item.isCaseCompleted) result += 'completed-case ';
    if (item.patientRecordCaseId === this.activeCase?.patientRecordCaseId)
      result += 'active-case ';
    if (item.reviewType === 'AI') result += 'ai-case ';
    if (item.reviewType === 'Dermatologist') result += 'derm-case ';
    return result;
  }

  getTypeLabel(item: PatientCaseModel): string {
    return item.reviewType === 'AI'
      ? this.translate.instant('followUpHistoryAiAnalysis')
      : this.translate.instant('followUpHistoryDermatologistReview');
  }

}
